import { render, staticRenderFns } from "./PatrolItemModal.vue?vue&type=template&id=56886450"
import script from "./PatrolItemModal.vue?vue&type=script&lang=js"
export * from "./PatrolItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports